import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { debounceTime, map, take } from 'rxjs/operators';
import { filter } from 'rxjs/internal/operators/filter';
import { NavigationControlFacade, NodeSharedFacade, TrainingSharedFacade } from '@medsurf/flat-facades';
import { Observable } from 'rxjs';

@Component({
    selector: 'medsurf-case-start',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './case-start.component.html',
    styleUrls: ['./case-start.component.scss'],
    standalone: false
})
export class CaseStartComponent {
  /**
   * Constructor
   *
   * @param trainingSharedFacade
   * @param nodeSharedFacade
   * @param navigationControlFacade
   * @param router
   */
  public constructor(public trainingSharedFacade: TrainingSharedFacade,
                     public nodeSharedFacade: NodeSharedFacade,
                     public navigationControlFacade: NavigationControlFacade,
                     public router: Router) {
    this.trainingSharedFacade.requestReset();
  }

  public redirectToCase(): Observable<boolean> {
    return this.nodeSharedFacade.currentSelectedCaseStartUrl$.pipe(
      filter((caseStartUrl) => caseStartUrl !== null),
      debounceTime(10),
      take(1),
      map(caseStartUrl => {
        if (caseStartUrl) {
          this.trainingSharedFacade.requestStartCase();
          return true;
        }
        return false;
      })
    );
  }
}
